export default {
  Yes: 1,
  No: 2,
};
